import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-gray-200 py-8 text-center text-sm text-gray-500">
      <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
        <Link to="/" className="hover:underline">
          Home
        </Link>
        <Link to="/app" className="hover:underline">
          Try Generator
        </Link>
        <Link to="/contact" className="hover:underline">
          Contact
        </Link>
      </div>
      <p className="mt-4">© {new Date().getFullYear()} Blitzname. All rights reserved.</p>
    </footer>
  );
}